import React, { useEffect, useState } from "react";
import "../BasicInformation/BasicInformation.css";
import AddressAutocomplete from "../../CustomGooglePlaceAPi/AddressAutocomplete";
import "../Locations/Locations.css";
import hotelImg from "../../../assets/images/golden-fern-img.png";
import imgNotFound from "../../../assets/images/single-image.png";

import { Link } from "react-router-dom";
import NoDataFound from "../../NoDataFound/NoDataFound";
import { showErrorToast, showSuccessToast } from "../../../assets/toastUtils";
import styles from "./MyProperties.module.scss";
import Loader from "../../Loader/Loader";

const MyProperties = () => {
  const [formData, setFormData] = useState({
    address: "",
  });
  const [loader, setLoader] = useState(false);

  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const vendorToken = localStorage.getItem("token");
  const [deletePopup, setDeletePopup] = useState(false);
  const [deletePropertyId, setDeleteProperyId] = useState(null);


  // console.log(userDetails);

  useEffect(() => {
    if (userDetails.accountId) {
      getProperties(userDetails.accountId);
    }
  }, [userDetails.id]);

  const [allProperties, setAllProperties] = useState([]);

  const [addressData, setAddressData] = useState({
    country: "",
    state: "",
    city: "",
    address: "",
    latitude: "",
    longitude: "",
    placeId: "",
  });

  const handleAddressData = (data) => {
    // console.log(data, "data");
    setAddressData(data);
  };

  // const getProperties = (id) => {
  //   const requestOptions = {
  //     // myHeaders.append("key", "D4X50uU40Vz4pweFLEmsoiJy107iPfTD4ompprop1");
  //     headers: {
  //       "Content-Type": "application/json",
  //       key: "D4X50uU40Vz4pweFLEmsoiJy107iPfTD4ompprop1",
  //       Authorization: "Bearer " + localStorage.getItem("token"),
  //     },
  //     method: "GET",
  //     redirect: "follow",
  //   };

  //   fetch(
  //     `${process.env.REACT_APP_APP_URL}/api/v1/vendor/get-accommodation/${id}`,
  //     requestOptions
  //   )
  //     .then((response) => response.json())
  //     .then((result) => {
  //       // console.log("result", result);

  //       if (result.success) {
  //         setAllProperties(result?.hotels);
  //       } else {
  //         setAllProperties([]);
  //       }
  //     })
  //     .catch((error) => console.error(error));
  // };

  const getProperties = async () => {
    setLoader(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");
      myHeaders.append("Authorization", `Bearer ${vendorToken}`);
      myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/accomodations/fetch`,
        requestOptions
      );

      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }

      const result = await response.json();
      setAllProperties(result?.hotels);
      setLoader(false);
    } catch (error) {
      console.error("Error fetching accommodations:", error);
      setLoader(false);
    }
  };

  function handleDeleteProperty(e, ids) {
    e.preventDefault();
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${vendorToken}`);
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

    const raw = JSON.stringify({
      ids: ids,
    });

    const requestOptions = {
      method: "DELETE",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/website/accomodation/crud/delete`,
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json(); // Assuming the response is JSON
      })
      .then((result) => {
        console.log(result, 'resu');

        if (result.success) {
          showSuccessToast(result.message);
          getProperties();
          setDeletePopup(false);
        } else {
          showErrorToast(result.message);
          setDeletePopup(false);
        }
      })
      .catch((error) => {
        console.error("Error deleting property:", error);
        setDeletePopup(false);
      });
  }

  return (
    <section className="w-full mt-10">
      <div className="">
        <div className={styles.agent_bookings_section}>
          <div className="flex align_items_center justify_content_between">
            <h4>Properties</h4>
            <Link
              to="/vendor/property/add"
              className="vendor_common_property"
            >
              <svg
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask
                  id="mask0_7193_3970"
                  style={{ maskType: "alpha" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="16"
                  height="17"
                >
                  <rect y="0.5" width="16" height="16" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_7193_3970)">
                  <path
                    d="M8 14.5C7.81111 14.5 7.65278 14.4361 7.525 14.3083C7.39722 14.1806 7.33333 14.0222 7.33333 13.8333V9.16667H2.66667C2.47778 9.16667 2.31944 9.10278 2.19167 8.975C2.06389 8.84722 2 8.68889 2 8.5C2 8.31111 2.06389 8.15278 2.19167 8.025C2.31944 7.89722 2.47778 7.83333 2.66667 7.83333H7.33333V3.16667C7.33333 2.97778 7.39722 2.81944 7.525 2.69167C7.65278 2.56389 7.81111 2.5 8 2.5C8.18889 2.5 8.34722 2.56389 8.475 2.69167C8.60278 2.81944 8.66667 2.97778 8.66667 3.16667V7.83333H13.3333C13.5222 7.83333 13.6806 7.89722 13.8083 8.025C13.9361 8.15278 14 8.31111 14 8.5C14 8.68889 13.9361 8.84722 13.8083 8.975C13.6806 9.10278 13.5222 9.16667 13.3333 9.16667H8.66667V13.8333C8.66667 14.0222 8.60278 14.1806 8.475 14.3083C8.34722 14.4361 8.18889 14.5 8 14.5Z"
                    fill=""
                  />
                </g>
              </svg>
              Add
            </Link>
          </div>

          <div className={styles.total_bookings_sec}>
            <div className={styles.total_bookings_sec_item}>
              Total Properties
              <span>{allProperties?.length || 0}</span>
            </div>
            <div className={styles.total_bookings_sec_item}>
              Total Rooms
              <span>
                {/* {
                      allBookingsCount?.filter(
                        (item) => item.status === "confirm"
                      ).length
                    } */}
                0
              </span>
            </div>
            <div className={styles.total_bookings_sec_item}>
              Confirmed Rooms
              <span>
                {/* {
                      allBookingsCount?.filter((item) => item.status === "hold")
                        .length
                    } */}
                0
              </span>
            </div>
            <div className={styles.total_bookings_sec_item}>
              Occupied Rooms
              <span>
                {/* {
                      allBookingsCount?.filter(
                        (item) => item.status === "cancelled"
                      ).length
                    } */}
                0
              </span>
            </div>
            <div className={styles.total_bookings_sec_item}>
              Vacant Rooms
              <span>
                {/* {
                      allBookingsCount?.filter(
                        (item) => item.status === "cancelled"
                      ).length
                    } */}
                0
              </span>
            </div>
          </div>
        </div>
        {loader ? (
          <Loader size="4em" color="#009A50" />
        ) : (
          <>
            {allProperties?.length > 0 ? (
              allProperties?.map((item, index) => {
                return (
                  <div className="bg-white-div mt-10" key={index}>
                    <Link to={`/partner/overview/${item?.id}`} target="_blank">
                      <div className="category_full_data">
                        <div className="flex flex_gap_10 align_items_center property_data">
                          <div className="property_img">
                            <img
                              src={
                                item?.featuredImage
                                  ? item?.featuredImage
                                  : imgNotFound
                              }
                              alt="logo-image"
                              className="hotel-img"
                              style={{
                                objectFit: "cover",
                                borderRadius: "6px",
                              }}
                            />
                          </div>
                          <div className="property_content">
                            <div className="flex align_items_center flex_gap_10 mb-10 flex_wrap">
                              {" "}
                              <h6 className="text-capitalize">{item?.name}</h6>
                              <span className="rating">
                                <svg
                                  width="14"
                                  height="13"
                                  viewBox="0 0 14 13"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7 0L8.5716 4.83688H13.6574L9.5429 7.82624L11.1145 12.6631L7 9.67376L2.8855 12.6631L4.4571 7.82624L0.342604 4.83688H5.4284L7 0Z"
                                    fill="white"
                                  />
                                </svg>
                                {item.starRating} Star
                              </span>
                            </div>
                            <span>
                              <svg
                                width="18"
                                height="19"
                                viewBox="0 0 18 19"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <mask
                                  id="mask0_7193_4027"
                                  style={{ maskType: "alpha" }}
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="18"
                                  height="19"
                                >
                                  <rect
                                    y="0.5"
                                    width="18"
                                    height="18"
                                    fill="#D9D9D9"
                                  />
                                </mask>
                                <g mask="url(#mask0_7193_4027)">
                                  <path
                                    d="M9.00216 9.39894C9.37528 9.39894 9.69428 9.26606 9.95916 9.00031C10.2242 8.73456 10.3567 8.41512 10.3567 8.042C10.3567 7.66887 10.2238 7.34981 9.95803 7.08481C9.69228 6.81994 9.37278 6.6875 8.99953 6.6875C8.62641 6.6875 8.30741 6.82038 8.04253 7.08613C7.77753 7.35188 7.64503 7.67138 7.64503 8.04463C7.64503 8.41775 7.77791 8.73675 8.04366 9.00163C8.30941 9.2665 8.62891 9.39894 9.00216 9.39894ZM9.00084 15.1351C10.4681 13.8216 11.5909 12.5618 12.3693 11.3555C13.1477 10.1493 13.5368 9.09275 13.5368 8.186C13.5368 6.81875 13.1025 5.69475 12.2337 4.814C11.365 3.93325 10.2873 3.49287 9.00084 3.49287C7.71434 3.49287 6.63672 3.93325 5.76797 4.814C4.89922 5.69475 4.46484 6.81875 4.46484 8.186C4.46484 9.09275 4.85403 10.1493 5.63241 11.3555C6.41078 12.5618 7.53359 13.8216 9.00084 15.1351ZM9.00084 16.6321C7.11334 14.9966 5.69797 13.4746 4.75472 12.0659C3.81147 10.6572 3.33984 9.36387 3.33984 8.186C3.33984 6.45525 3.89966 5.05406 5.01928 3.98244C6.13903 2.91081 7.46622 2.375 9.00084 2.375C10.5355 2.375 11.8627 2.91081 12.9824 3.98244C14.102 5.05406 14.6618 6.45525 14.6618 8.186C14.6618 9.36387 14.1902 10.6572 13.247 12.0659C12.3037 13.4746 10.8883 14.9966 9.00084 16.6321Z"
                                    fill="#888888"
                                  />
                                </g>
                              </svg>
                              {item?.address}
                            </span>
                          </div>
                        </div>
                        <div className="data_desc">
                          <div className="category_data">
                            <div>
                              <span>Type</span>
                              <span>{item?.type}</span>
                            </div>
                            <div>
                              <span>Category</span>
                              <span>{item?.category}</span>
                            </div>
                          </div>
                          <div className="flex flex_gap_10 align_items_center">
                            {/* <Link className="secondary_btn" to={`/rates/${item?.id}`}>
                        rates
                      </Link> */}

                            <Link
                              to={`/vendor/property/edit/${item?.id}`}
                              style={{ color: "#016937" }}
                            >
                              <svg
                                width="26"
                                height="27"
                                viewBox="0 0 26 27"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <mask
                                  id="mask0_4568_4221"
                                  style={{ maskType: "alpha" }}
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="26"
                                  height="27"
                                >
                                  <rect
                                    y="0.5"
                                    width="26"
                                    height="26"
                                    fill="#009A50"
                                  />
                                </mask>
                                <g mask="url(#mask0_4568_4221)">
                                  <path
                                    d="M5.41667 21.0833H6.96042L17.55 10.4938L16.0063 8.95L5.41667 19.5396V21.0833ZM3.25 23.25V18.6458L17.55 4.37292C17.7667 4.17431 18.0059 4.02083 18.2677 3.9125C18.5295 3.80417 18.8049 3.75 19.0938 3.75C19.3826 3.75 19.6625 3.80417 19.9333 3.9125C20.2042 4.02083 20.4389 4.18333 20.6375 4.4L22.1271 5.91667C22.3438 6.11528 22.5017 6.35 22.601 6.62083C22.7003 6.89167 22.75 7.1625 22.75 7.43333C22.75 7.72222 22.7003 7.99757 22.601 8.25938C22.5017 8.52118 22.3438 8.76042 22.1271 8.97708L7.85417 23.25H3.25ZM16.7646 9.73542L16.0063 8.95L17.55 10.4938L16.7646 9.73542Z"
                                    fill="#009A50"
                                  />
                                </g>
                              </svg>
                            </Link>

                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault(); // prevent link navigation
                                setDeleteProperyId(item?.id);
                                setDeletePopup(true);
                              }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                height="24px"
                                viewBox="0 -960 960 960"
                                width="24px"
                                fill="#FE3500"
                              >
                                <path d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z" />
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>
                    </Link>

                  </div>
                );
              })
            ) : (
              <>
                <NoDataFound />
              </>
            )}
          </>
        )}
      </div>

      {deletePopup && (
        <div className="popup_backdrop">
          <div className="popup_section p_20">
            <div>
              <div className="flex justify_content_between">
                <h4>Are you sure to Delete.</h4>
                <svg
                  onClick={() => setDeletePopup(false)}
                  width="14"
                  height="13"
                  viewBox="0 0 14 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 12.5L13 0.5"
                    stroke="#AAAAAA"
                    strokeWidth="1.2"
                  />
                  <path
                    d="M13 12.5L1 0.5"
                    stroke="#AAAAAA"
                    strokeWidth="1.2"
                  />
                </svg>
              </div>

              <button
                className="vendor_common_property mt-10 w-full"
                type="button"
                // onClick={() => deleteRatePlan()}
                onClick={(e) => handleDeleteProperty(e, [deletePropertyId])}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default MyProperties;